export const formatDate = (date: any, dateUnit: string) => {
    let year, day, month = ''
    if (date) {
        year = date.split('-')[0];
        month = date.split('-')[1];
        day = date.split('-')[2];
        day = day.split('T')[0];
        if (dateUnit === 'USA: MM/DD/AAAA') {
            return month + '/' + day + '/' + year;
        } else if (dateUnit === 'ISO: AAAA/MM/DD') {
            return year + '/' + month + '/' + day;
        } else {
            return day + '/' + month + '/' + year;
        }
    } else {
        return ''
    }
}

export const formatHour = (hourUnit: string) => {
    let hour: any, min: any
    hour = new Date().getHours();
    min = new Date().getMinutes();

    if (hourUnit === 'AM/PM') {
        var newformat = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        hour = hour ? hour : 12;
        hour = hour < 10 ? '0'.concat(hour) : hour;
        min = min < 10 ? '0'.concat(min) : min;
        return hour + ':' + min + ' ' + newformat;
    } else {
        hour = hour < 10 ? '0'.concat(hour) : hour;
        min = min < 10 ? '0'.concat(min) : min;
        return hour + ':' + min
    }
}

export const getCurrentDateTimezone = () => {
    const currentDate = new Date();
    currentDate.setMinutes(currentDate.getMinutes() - currentDate.getTimezoneOffset());
    const currentDateFormated = currentDate.toISOString();

    return currentDateFormated;
};